export default "__VITE_ASSET__CTFzfXJe__"